import { CampaignLoa, CampaignLoaDocParams } from './types';
import { globalGetService } from '@/utils/globalApiServices';
import { getFilenameFromContentDisposition } from '@/utils/file';

export const getLoas = async (campaignUid: string) => {
  const response = await globalGetService(`mno/campaigns/${campaignUid}/LOA`);
  return (response?.ok ? response.data : []) as CampaignLoa[];
};

export const getLoaDoc = async (
  campaignUid: string,
  docUid: string,
  params: CampaignLoaDocParams
) => {
  const isPdf = params?.format === 'pdf';
  const response = await globalGetService(
    `mno/campaigns/${campaignUid}/LOA/${docUid}`,
    params,
    isPdf ? { responseType: 'arraybuffer' } : undefined
  );

  if (response?.ok) {
    const filename = getFilenameFromContentDisposition(
      response.headers?.['content-disposition'],
      'LOA.pdf'
    );
    return {
      data: response.data,
      filename,
    };
  }
  return undefined;
};
